<template>
  <b-modal
      :dialog-class="'modal-input ' + (!isExpanded ? '' : 'b-dialog-large')"
      scrollable 
      :no-close-on-backdrop=true 
      :title="label" 
      :no-close-on-esc=true 
      v-model="show" 
      :ok-title="okTitle" 
      ok-variant="success" 
      @hidden="onHidden">
      <template #modal-header>
        <div class="w-100">
          <b-row>
            <b-col cols="12" md="9" :class="'d-flex pl-sm-0 pl-md-3' + showLeftIcon ? ' modal-title-icon ' : ''">
              <span class="mr-1 d-sm-flex d-md-none">
                  <b-button size="sm" class="ml-1 btn-back " @click="$emit('close')"><b-icon-arrow-left /></b-button>
              </span>
              <span v-if="showLeftIcon" class="icon-add">
                <img :src="'/img/' + leftIcon" class="img-icon-add" />
              </span>
              <h5 class="modal-title"><app-long-text :maxLength="15" :mdMaxLength="50" :text="label" /></h5>
            </b-col>
            <b-col cols="3">
              <span class="float-right d-md-block d-sm-none">
                  <button v-if="false" class="close" no-variant @click="$bvModal.hide('modal-input')">x</button>
                  <b-button size="sm" v-if="!isExpanded" variant="transparent" class="expand border-0 mt-1" @click="isExpanded = true">
                    <b-icon-arrows-angle-expand />
                  </b-button>
                  <b-button size="sm" v-else variant="transparent" class="expand border-0 mt-1" @click="isExpanded = false">
                    <b-icon-arrows-angle-contract />
                  </b-button>
              </span>
            </b-col>
          </b-row>
        </div>
      </template>
      <div>
        <slot/>
        <PopupApprovalHistory label="Approval History" :openPopup="isShowApprovalHistory" @resetModalMethod="resetMethod" :approvalInstanceId="approvalInstanceId" />
      </div>
      <template #modal-footer="{ ok }">
        <b-col class="p-0" cols="2">
          <b-button v-if="showApprovalHistoryButton" size="sm" variant="secondary" class="float-left" @click="showApprovalHistory()">
              Approval History
          </b-button>
        </b-col>
        <b-col class="p-0" cols="10">
          <slot name="modal-left-button"></slot>
          <b-overlay
              :show="isBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="float-right mr-2"
              >
            <b-button v-if="showApproveButton" size="sm" class="float-right btn-default" @click="approveAction">
              {{ approveButtonTitle }}
            </b-button>
          </b-overlay>
          <b-overlay
              :show="isBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="float-right mr-2"
              >
            <b-button v-if="showRejectButton" size="sm" class="float-right btn-default-white" @click="rejectAction">
              {{ rejectButtonTitle }}
            </b-button>
          </b-overlay>
          <b-overlay
              :show="isBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="float-right mr-2"
              >
            <b-button v-if="showRevisionButton" size="sm" class="float-right btn-default-white" @click="revisionAction">
              {{ revisionButtonTitle }}
            </b-button>
          </b-overlay>
          <b-button size="sm" class="float-right  mr-2 btn-default-white" @click="ok()">
            {{ okTitle }}
          </b-button>
        </b-col>
      </template>
  </b-modal>
</template>

<script>
import PopupApprovalHistory from './PopupApprovalHistory.vue';

export default {
  name: 'PopupWrap',
  //props: ["copyDataMethod", "isShowCopyData", "label"],
  components: {PopupApprovalHistory},
  props: {
    copyDataMethod: {},
    isShowCopyData: {
      default: true,
      type: Boolean,
    },
    label: {
      required: true,
      type: String,
    },
    okTitle: {
      default: 'Close',
      type: String,
    },
    cancelTitle: {
      default: 'Copy Data',
      type: String,
    },
    okVariant: {
      default: 'success',
      type: String,
    },
    cancelVariant: {
      default: 'secondary',
      type: String,
    },
     isBusy: {
      default: false,
      type: Boolean,
    },
    approveMethod: {},
    showApproveButton: {
      type: Boolean,
      default: true
    },
    approveButtonTitle: {
      default: 'Approve Request',
      type: String,
    }, 
    approveButtonVariant: {
      default: 'success',
      type: String,
    },
    rejectMethod:{},
    showRejectButton: {
      type: Boolean,
      default: true
    },
    rejectButtonTitle: {
      default: 'Reject Request',
      type: String,
    },
     rejectButtonVariant: {
      default: 'warning',
      type: String,
    },
    revisionMethod:{},
    showRevisionButton: {
      type: Boolean,
      default: true
    },
    revisionButtonTitle: {
      default: 'Revise Request',
      type: String,
    },
     revisionButtonVariant: {
      default: 'default',
      type: String,
    },
    showApprovalHistoryButton: {
      type: Boolean,
      default: true
    },
    showLeftIcon: {
      type: Boolean,
      default: false
    },
    leftIcon: {
      default: 'add-icon.png',
      type: String,
    },
    approvalInstanceId: {
      value: [String,Number],
    }
  },
  data() {
    return {
      show : true,
      isShowApprovalHistory: false,
      isExpanded: false,
    }
  },
  mounted() {
    const close = (e) => {
      const ESC = 27;
      if (e.keyCode !== ESC) return;
      this.$emit('close');
    };

    /*document.addEventListener('keyup', close);
    this.$on('hook:destroyed', () => {
      document.removeEventListener('keyup', close);
    });*/

    this.activate();
    this.$on('hook:destroyed', () => {
      this.deactivate();
    });
  },
  computed : {
    showCopyData() {
      if (this.isShowCopyData != null && this.isShowCopyData != undefined) return this.isShowCopyData;
      return true;
    }
  },
  methods: {
    async approveAction(modalEvent, model) {
      this.$emit("approveMethod", modalEvent, this.$emit);
    },
    async rejectAction(modalEvent, model) {
      this.$emit("rejectMethod", modalEvent);
    },
    revisionAction(modalEvent, model) {
      this.$emit("revisionMethod", modalEvent);
    },
    activate() {
      this.previousActiveElement = document.activeElement;
      this.inert();
    },
    showApprovalHistory() {
      this.isShowApprovalHistory = true;
    },
    resetMethod() {
      this.isShowApprovalHistory = false;
    },
    async deactivate() {
      await this.inert(false);
    },
    async inert(status = true) {
      await this.$nextTick();
      [...this.$root.$el.children].forEach((child) => {
        if (child === this.$el || child.contains(this.$el)) return;
        child.inert = status;
      });
    },
    onHidden() {
      this.$emit('hideMethod');
      this.$emit('close');
    },
  },
};
</script>

<style>
.modal-body {
  background: #EEF0F8 !important;
}
</style>